import React, { Component, Fragment } from 'react'
import { withStyles } from "@material-ui/styles";
import { Link, withRouter } from 'react-router-dom'
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box'; 
import MaterialTable, { MTableToolbar } from 'material-table';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import PageTitle from '../../../components/PageTitle/PageTitle';
import GridContainer from '../../../components/Custom/Grid/GridContainer';
import GridItem from '../../../components/Custom/Grid/GridItem';
import TableIconsComponent from '../../../components/TableLogo/TableIconsComponent';
import ApiService, { showToast, Status } from '../../ApiService/ApiService';
import ObjectUtils from '../../../util/objectUtil';
import CustomInput from '../../../components/Custom/CustomInput/CustomInput';
import { BLOCK_EMAIL_GET_ALL, BLOCK_EMAIL_ADD, BLOCK_EMAIL_REMOVE } from '../../ApiService/URLs';
import Button from '../../../components/Custom/Button/Button';

const useStyles = theme => ({
  theme: theme,
  searchbar: {
	margin: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
  },

});

class EmailBlockComponent extends Component {

	constructor(props) {
		 super(props)
		 this.state = {
			blockEmails : [],
			responsemessage: null,
			email: null,
			blockEmailValidation: {}
		}
	 	this.handleChange = this.handleChange.bind(this);
		this.reloadData = this.reloadData.bind(this);
		this.blockEmail = this.blockEmail.bind(this);
	}

	handleChange(event) {
        this.setState({[event.target.name]: event.target.value, critChanged: true })
    }

	componentDidMount() {
		this.reloadData();
	}

	reloadData() {
		ApiService.postAPI(BLOCK_EMAIL_GET_ALL, {merchantId : this.props.merchantId}).then((res) => {
			if (res != null) {
				if(res.data.status === "success") {
					this.setState({blockEmails: res.data.data});
				} else {
					showToast({ type: Status.ERROR, title: "Error", description: res.data.statusText });
				}
			}
			//alert("re.data" + res.data);
		});
	}
	
	blockEmail() {
		if (ObjectUtils.isNullorEmpty(this.state.email)) {
			this.setState ({blockEmailValidation : {helperType : Status.ERROR, helperText: "Email is required"}});
			return;
		}
		
		if (!ObjectUtils.isValidEmail(this.state.email))	{
			this.setState ({blockEmailValidation : {helperType : Status.ERROR, helperText: "Email is invalid"}});
			return;
		}
		
		const reqObj = { merchantId : this.props.merchantId, email: this.state.email };
		ApiService.postAPI(BLOCK_EMAIL_ADD, reqObj).then((res) => {
			if (res != null) {
				if(res.data.status === "success") {
					showToast({ type: Status.SUCCESS, title: "Add", description: res.data.message });
					this.setState ({email: "", blockEmailValidation : {}}, () => this.reloadData());
				} else {
					showToast({ type: Status.ERROR, title: "Error", description: res.data.message });
				}
			}
		});
	}

	unblockEmail(data) {
		const reqObj = { merchantId : this.props.merchantId, id: data.id };
		ApiService.postAPI(BLOCK_EMAIL_REMOVE, reqObj).then((res) => {
			if (res != null) {
				if(res.data.status === "success") {
					this.reloadData();
					showToast({ type: Status.SUCCESS, title: "Delete", description: res.data.message });
				} else {
					showToast({ type: Status.ERROR, title: "Error", description: res.data.message });
				}
			}
		});
	}

    render() {
        const { classes } = this.props; 
		const { email, blockEmailValidation } = this.state; 
	 
        return (<>
				<GridContainer>
					<GridItem xs={8} sm={9} md={5} lg={4}>
						<CustomInput title="Email" field="email"
							formControlProps={{ fullWidth: true }}
							inputProps={{
								value: email,
								name: "email",
								onChange: this.handleChange
							}}
							helperType={blockEmailValidation.helperType}
							helperText={blockEmailValidation.helperText}
						/>
					</GridItem>
					<GridItem xs={4} sm={3} md={7} lg={8}>
						<Button variant="contained" className={classes.searchbar} color="primary" size="sm" onClick={this.blockEmail}>
							Block Email
						</Button>
					</GridItem>
				</GridContainer>
				<Divider/>
				<GridContainer>
					<GridItem xs={12} sm={12} md={12} lg={12}>
						<>
							<MaterialTable 
							title="Blocked Emails"
							icons={TableIconsComponent.icons}
							columns={[ 
								{ field: 'email',numeric: false, title: 'Email'},
							]}
							data={this.state.blockEmails}
							actions={[						
								{
									tooltip: 'Unblock Email',
									icon: (props)=> <DeleteIcon {...props} />,
									onClick: (evt, data) => this.unblockEmail(data),
								}
							]}
							options={{
								headerStyle: { 
									whiteSpace: 'nowrap', backgroundColor: "#fff", 
									color: "#000", fontSize: 12
								},
								search:false,
								exportButton: false,
								pageSize: 10,
								pageSizeOptions: [10,20],
								padding: 'dense',
								showEmptyDataSourceMessage: true,
								emptyRowsWhenPaging: false,
							}}
							/>
						</>
				 	</GridItem>
				</GridContainer>
			 </>)
    }
}

export default withStyles(useStyles)(EmailBlockComponent)
